// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"b7c7c89a","63":"e2fb2105","300":"ecd71d70","320":"90d57b23","510":"c5482ce4","529":"b6e0aca1","649":"7a51fdcf","753":"30381103","835":"53cd0152","855":"36b9e667","873":"9497c0a3","978":"27ab4806"}[chunkId] + ".chunk.js";
};